import React, {useContext} from 'react'
import {ReducerContext} from './reducer'
import ParetoChart from '../ParetoChart'
import NoData from './NoData'
// Add xlsx and file-saver for export
import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'

var paretoData = {}

export default function Chart() {
  const {state} = useContext(ReducerContext)

  paretoData = {}
  let numQuestions = 0
  
  // Use chart_data if available, otherwise fall back to data
  const chartData = state.chart_data || state.data;
  
  console.log('Chart rendering with data:', {
    chart_data: state.chart_data,
    data: state.data,
    chartData: chartData,
    questionsLength: chartData?.questions?.length
  });
  
  if (chartData && chartData.questions && chartData.questions.length > 0) {
    let showFields = chartData.questions
    let selectedSection = state.sections && state.dropdown && state.sections.filter((section) => section.id == state.dropdown.section).filter((e) => e)[0]

    if (selectedSection && selectedSection.id !== 'All') {
      showFields = showFields.filter((field) => selectedSection.order.includes(field.field_id))
    }
    
    showFields.forEach((question_data) => {
      const value = question_data.num_fail || question_data.failed;

      if (value !== undefined && value !== null && value !== '') {
        paretoData[question_data.question] = value;
      }
    })
    numQuestions = showFields.length
  }

  // Export as XLSX handler
  function handleExportXLSX() {
    // Prepare data as array of objects
    const dataArr = Object.entries(paretoData).map(([question, value]) => ({
      Question: question,
      'Number of Failures': value
    }))
    // Create worksheet and workbook
    const ws = XLSX.utils.json_to_sheet(dataArr)
    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, 'Pareto Chart')
    // Write to blob and save
    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
    saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'pareto_chart.xlsx')
  }

  let returnDiv
  if (chartData && chartData.questions && chartData.questions.length > 0 && Object.keys(paretoData).length > 0) {
    returnDiv = (
      <div style={{float: 'center'}}>
        <button onClick={handleExportXLSX} style={{marginBottom: 16}}>Export as XLSX</button>
        <ParetoChart data={paretoData} />
        <div>Viewing data calculated on {chartData.created ? new Date(chartData.created.seconds * 1000).toUTCString() : ''}</div>
      </div>
    )
  } else if (chartData && (!chartData.questions || chartData.questions.length === 0)) {
    // Determine user type based on aggregation
    const userType = state.dropdown.aggregation === 'reviewer' 
      ? 'reviewer'
      : state.dropdown.aggregation === 'installer' 
        ? 'installer'
        : 'field user';
    
    const selectedUser = state.dropdown.aggregation === 'reviewer' 
      ? state.dropdown.reviewer 
      : state.dropdown.aggregation === 'installer'
        ? state.dropdown.installerUser
        : state.dropdown.fieldUser;
    
    returnDiv = (
      <div style={{textAlign: 'center', padding: '20px'}}>
        <p>No data available for the selected {userType}.</p>
        {selectedUser && selectedUser !== 'All' && selectedUser !== 'select' && (
          <p>The selected {userType} has no associated question results.</p>
        )}
        <p>Try selecting:</p>
        <ul style={{textAlign: 'left', display: 'inline-block'}}>
          <li>A different {userType}</li>
          <li>&quot;All {userType}s&quot; option to see aggregated data</li>
          <li>Switch to another aggregation type</li>
        </ul>
      </div>
    )
  } else {
    returnDiv = <NoData />
  }

  return returnDiv
}
